import { render, staticRenderFns } from "./Credit1372.vue?vue&type=template&id=487e8ef0&"
import script from "./Credit1372.vue?vue&type=script&lang=js&"
export * from "./Credit1372.vue?vue&type=script&lang=js&"
import style0 from "./Credit1372.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports